<template>
  <div class="text-center mt-32 bg-white py-4">
    <div class="pt-20 w-1/2 mx-auto flex flex-col" v-if="!addTeacher && !masterclass && !meeting">
      <dashboard-button class="py-5" buttonPlaceholder="Add new Teacher"
        @click="openAddTeacherView" />
      <!--<dashboard-button class="py-5" buttonPlaceholder="Manage Masterclass"
        @click="openMasterclassView" />-->
      <dashboard-button class="py-5" buttonPlaceholder="Join a Meeting"
        @click="joinAMeeting" />
    </div>
    <div v-if="addTeacher">
      <dashboard-button class="py-10" buttonPlaceholder="Back to home"
        @click="backHome" />
      <teacher-registration />
    </div>
    <div v-if="masterclass">
      <dashboard-button class="py-10" buttonPlaceholder="Back to home"
        @click="backHome" />
      <masterclass-management />
    </div>
    <div v-if="meeting">
      <dashboard-button class="py-10" buttonPlaceholder="Back to home"
        @click="backHome" />
      <lessons-list />
    </div>

    <update-password class="w-1/2 mx-auto text-left"
      v-if="!addTeacher && !masterclass && !meeting" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DashboardButton from '../components/DashboardButton.vue';
import TeacherRegistration from '../components/admin/TeacherRegistration.vue';
import MasterclassManagement from '../components/admin/MasterclassManagement.vue';
import LessonsList from '../components/admin/LessonsList.vue';
import UpdatePassword from '../components/UpdatePassword.vue';

export default {
  mixins: [StreamFunctionsMixin],

  data() {
    return {
      addTeacher: false,
      masterclass: false,
      meeting: false,
    };
  },

  components: {
    DashboardButton,
    TeacherRegistration,
    MasterclassManagement,
    LessonsList,
    UpdatePassword,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  methods: {
    openAddTeacherView() {
      this.addTeacher = true;
    },
    openMasterclassView() {
      this.masterclass = true;
    },
    joinAMeeting() {
      this.meeting = true;
    },
    backHome() {
      this.addTeacher = false;
      this.masterclass = false;
      this.meeting = false;
    },
  },

};
</script>
